<template>
  <p class="mt-5 mb-3 text-muted">
    © {{ date }} <LanguageSwitcher />
  </p>
</template>

<script>
import LanguageSwitcher from '@/modules/localization/components/LanguageSwitcher.vue';
import Tr from '@/modules/localization/translation';
export default {
  components: { LanguageSwitcher },
  setup() {
    return { Tr };
  },
  computed: {
    date() { return new Date().getFullYear(); },
  },
};
</script>
